module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_photowedding_01@3x-b31e8b1c59487b42c2783626a601d41b.webp";